<!-- Topbar -->
<nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

    <!-- Sidebar Toggle (Topbar) -->
    <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
        <i class="fa fa-bars"></i>
    </button>
    <img src="../../assets/img/logo.jpg" alt="" width="150" height="50" style="padding: auto;">
    <!-- Topbar Search -->
    <form
        class="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
        <div class="input-group">
            
            <input [formControl]="searchControl"  type="text"  class="form-control bg-light border-0 small" placeholder="Search for..."
                aria-label="Search" aria-describedby="basic-addon2" >

            <div class="input-group-append">
                <button class="btn btn-primary"  type="button" (click)="search()">
                    <mat-icon style="margin-top: 20%;">search</mat-icon>
                </button>
            </div>
        </div>
    </form>

   

</nav>
<!-- End of Topbar -->